module.exports = __webpack_public_path__ + "static/media/vos-app.8d00e280.webp";